import { useQuery } from '@tanstack/react-query'
import { unitDetails } from '../api/bol'
import type { UnitDetails } from '../api/types'

export function unitDetailsQueryKey(unitId: number, blockId: number) {
    return ['unit-details', unitId, blockId] as const
}

/**
 * Everything the pane displays below the header comes from this one call —
 * ownership, balances, statements, credit control cases, tickets, people and portal
 * users. See GET /api/v1/core/units/{unit_id}/details.
 */
export function useUnitDetails(unitId: number | undefined, blockId: number | undefined) {
    return useQuery<UnitDetails>({
        queryKey: unitDetailsQueryKey(unitId ?? 0, blockId ?? 0),
        enabled: unitId !== undefined && blockId !== undefined,
        staleTime: 60 * 1000,
        retry: false,
        queryFn: ({ signal }) => unitDetails(unitId!, blockId!, signal),
    })
}
